<template>
  <div>
    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清管理'}]" />
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
				<div class="h-thirdColumn w-newColumn">
					<el-form-item label="提报时间">
						<el-date-picker
						 :clearable="false"
						  type="date"
						  placeholder="选择时间"
						  v-model="q.cdsDate"
						  style="width: 100%;"
						  value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="提报人">
						<el-input v-model="q.cunameLike" placeholder="请输入提报人姓名" :clearable="true"></el-input>
					</el-form-item>
					<el-form-item label="区域">
						<brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"></brselect>
					</el-form-item>
			  </div>	
            
            <div class="h-formBtnOut h-columnCenter">
				<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
				<el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
				<el-button v-if="isfb==1" class="h-btn h-formBtn h-bggreen" @click="publishRank">发布排行</el-button>
				<el-button class="h-btn h-formBtn h-bggreen" @click="checkRank">查看总排名</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          stripe
		  max-height="560"
          style="width: 100%"
          >
          <el-table-column type="selection" width="45" label="全选"></el-table-column>
          <el-table-column fixed type="index" label="#" width="40"></el-table-column>
            <el-table-column prop="ghRole" label="角色" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="cuname" label="提报人" width="80" :show-overflow-tooltip="true"></el-table-column>
		  <el-table-column prop="cdate" label="提报时间"  width="160" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="careTotal" label="拜访次数" width="90" :show-overflow-tooltip="true">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.careTotal}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column prop="resTotal" label="资源需求" width="90" :show-overflow-tooltip="true">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.resTotal}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column
                  prop="adjScore"
                  label="当日评分"
				  width="130"
				  :show-overflow-tooltip="true"
                  >
            <template slot-scope="scope">
                  <brselect class="h-tableInput" category="userCareLevel" :v="scope.row.adjScore" v-model="scope.row.adjScore"/>
            </template>
          </el-table-column>
          <el-table-column
                  prop="adjReason"
                  label="调整原因"
				  min-width="250"
				  :show-overflow-tooltip="true"
                 >
            <template slot-scope="scope">
                  <el-input class="h-tableInput" v-model="scope.row.adjReason" :clearable="true"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="orderTotal" label="订单需求"  width="90" :show-overflow-tooltip="true">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.orderTotal}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column prop="sysScore" label="系统评分" width="90" :show-overflow-tooltip="true">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.sysScore}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
				<div style="text-align: left;">
					<el-button
					   type="text"
					   size="small"
					   class="h-tableLink h-btn"
					   @click="checkDetail(scope.row.id)"
					 >查看</el-button>
					 <!-- <el-button
					 v-show="scope.row.status==1"
					   type="text"
					   size="small"
					   class="h-tableLink h-btn"
					   @click="shenhe(scope.row.id)"
					 >审核</el-button> -->
					<el-button
					   v-show="scope.row.instid"
					   size="small" class="h-tableLink h-btn"
					   @click="genzongLiuch(scope.row)">
					   跟踪
					 </el-button>
				</div>
              
			 <!-- <div class="l-operationBox">
			  	<span class="l-operationlist br-operation-look" title="查看" @click="checkDetail(scope.row.id)"></span>
			  	<span class="l-operationlist br-operation-spgz" v-show="scope.row.instid" title="跟踪审批" @click="genzongLiuch(scope.row)"></span>
			  </div> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" @click="saveGrade">调整评分</el-button>
            <!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export">批量导入</el-button> -->
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  <!-- 发布弹框 -->
  <el-dialog :close-on-click-modal="false" title="发布提醒" :visible.sync="dialogFlag" custom-class="body_dilog">
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon">
                        <!-- <div class="h-formBox" style="margin-bottom: 1px;">
                            <div>{{nosum}}</div>
                            <div>{{nosoc}}</div>
                            <br>
                        </div> -->
                        <div class="h-formBox" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q2" class="demo-form-inline h-formBorder">
                                <el-form-item label="日清状态">
                                    <el-select v-model="q2.rqstatus" clearable placeholder="--请选择--">
                                        <el-option label="已提交已审核" value="1"></el-option>
                                        <el-option label="已提交未审核" value="2"></el-option>
                                        <el-option label="未提交" value="3"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut">
                                    <el-button class="h-btn h-formBtn h-bgblueQ"  icon="el-icon-search" @click="queryRank">搜索</el-button>
                                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon" @click="publicPh">发布排行</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                size="mini"
                                ref="multipleTable"
                                :data="sumRank"
                                :border="true"
                                tooltip-effect="dark"
								border
                                style="width: 100%"
                                @selection-change="handleSelectionChangeDialog"
                                >
                            <el-table-column type="selection" width="55" label="全选"></el-table-column>
                            <el-table-column type="index" :index="typeIndex" label="排行" width="60"></el-table-column>
                            <el-table-column
                                    prop="userCode"
                                    label="账号"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="cuname"
                                    label="姓名"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="adjScore"
                                    label="等级"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="cdsDate"
                                    label="提报时间"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="sysScore"
                                    label="系统评分"
                                    >
                            </el-table-column>
                        </el-table>
						<div class="h-tableB h-mrt30">
						  <div class="h-tableBL ljjcaozuo" style="display: flex;justify-content: center;align-items: center;">
						    <el-button style="text-align: center;" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-edit" @click="publicQj">请假</el-button>
						    <el-button style="text-align: center;" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-edit" @click="publicQxQj">取消请假</el-button>
						  </div>

						</div>
						<div class="h-pagination2">
						  <paginationmin :page="q2" @query="queryRank" />
						</div>

                    </div>
                </div>
            </div>
        </el-dialog>

  </div>
</template>

<script>
import ss from "../../api/SystemService";
import updownfile from '../../utils/updownfile'
export default {
  data() {
    return {
      //表单
      q: {
          cdsDate:null,
          pageSize: 10,
          pageNo: 1,
          total:0,
      },
      isfb:1,
      showhistory:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
      //表格
      multipleSelection: [],
      multipleSelectionDialog:[],
      tableData: [],
      //发布排行
      dialogFlag:false,
      sumRank:[],
      nosum:'',
      nosoc:'',
      q2: {
          pageSize: 10,
          pageNo: 1,
          total:0,
          rqstatus:'',
      },
    };
  },
  created() {
  },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {
    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //弹框表格
    handleSelectionChangeDialog(val){
      this.multipleSelectionDialog = val;
    },
    query(){
      ss.UserCare.page(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    shenhe(id){
      //修改
      this.$router.push({path: '/presentation', query: {rqId:id }});
    },
    myrank() {
      ss.UserCare.gradeRanking({}).then(rd => {
        if(rd.obj&&rd.obj.adjScore){
          this.pingfen=rd.obj.adjScore;
        }
        if(rd.obj&&rd.obj.orderNo){
          this.paiming=rd.obj.orderNo;
        }

      });
    },
    handleFilter() {
      this.query();
    },
    checkRank() {
      this.$router.push("/paiming");
    },
    publishRank(){
      //发布排行
      if(this.q.cdsDate){
        // ss.UserCare.publishCheck(this.q).then(rd => {
        //     //查询这一天的用户人数，审核情况等
        //     this.dialogFlag=true;
        //     this.nosum=rd.todayMap.noSum;
        //     this.nosoc=rd.todayMap.noSco;
        // })
        var rank={orderType:3,orderDate:this.q.cdsDate}
        ss.UserCare.publishedCheck(rank).then(rd => {
            if(rd.result&&rd.result.length>0){
              this.$msg.msge(this.q.cdsDate+"日清排行已发布");
            }else{
              //查询是否已经发布
              this.q2.rqstatus="";
              this.queryRank();
            }
        })

      }else{
        this.$msg.msge("请先选择提报时间");
      }
    },
    queryRank(){
        this.q2.cdsDate=this.q.cdsDate;
        ss.UserCare.publishPage(this.q2).then(rd => {
            //查询这一天的用户人数，审核情况等
            this.dialogFlag=true;
            this.sumRank=rd.records;
            this.q2.total = rd.total;

        })
    },
    typeIndex(index){
      return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
    },
    publicPh(){
      //发布排行
      ss.UserCare.publicPh(this.q).then(rd => {
          this.dialogFlag=false;
          this.$msg.msgs("发布成功，榜单将于2个小时内放榜");
      })
    },
    publicQj(){
      var tjflag=true;
      var rqlist=[];
        this.multipleSelectionDialog.forEach(element => {
          if(element.sysScore||element.sysScore==0){
            tjflag=false;
          }
        element.adjScore="请假";
        element.cdsDate=this.q2.cdsDate;
        rqlist.push(element);
      });

      if(tjflag){
          //勾选的请假
        ss.UserCare.publicQj({summaryList:rqlist}).then(rd => {
            this.$msg.msgs("已更新请假信息");
            this.q2.rqstatus="";
            this.queryRank();
        })
      }else{
        this.$msg.msge("请选择未提交日清的用户操作请假");
      }

    },
    publicQxQj(){
      var rqlist=[];
      var tjflag=true;
        this.multipleSelectionDialog.forEach(element => {
        if(element.adjScore!= "请假"){
          tjflag=false;
        }
        element.delflag="0";
        element.cdsDate=this.q2.cdsDate;
        rqlist.push(element);
      });
      //勾选的请假
      if(tjflag){
        ss.UserCare.publicQj({summaryList:rqlist}).then(rd => {
            this.$msg.msgs("已取消请假");
            this.q2.rqstatus="";
            this.queryRank();
        })
      }else{
        this.$msg.msge("请选择请假的用户操作");
      }
    },
    riqingtb(){
      ss.UserCare.riqiFlag({}).then(rd => {
        if(rd.obj==0){
          this.$router.push("/presentation");
        }else{
          this.$message({
            message: '今日日清已提交，请勿重复提交',
            type: 'warning'
          });
        }

      });
    },
    checkDetail(id){
      //查看详情
      this.$router.push({path: '/presentation2', query: {rqId:id }});
    },
    //明细导出
			exportExcel() {
				var idlist=[];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.q.ids = idlist
                updownfile.down("/api/swyl/v1/guanhuai/userCareDailySummary/downloadExcel",this.q,"post",'data');
      },
      //调整评分
      saveGrade(){
        console.log("调整评分数据",this.tableData);
        var tjflag=true;
        this.tableData.forEach(element => {
          //console.log(element.sysScore,element.sysReason,element.adjScore,element.cuname);
            if((element.sysScore||element.sysScore==0)&&element.adjScore==-1){
              //console.log(element.sysScore,element.sysReason,element.adjScore,element.cuname);
              tjflag=false;
            }
        })
        if(tjflag){
          ss.UserCare.tzGrade({"summaryList":this.tableData}).then(rd => {
            this.$msg.msgs("调整保存成功");
            this.query();
          })
        }else{
          this.$msg.msge("请选择未提交日清的用户操作请假");
        }

      },
    //重置
    rest() {
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
          pageSize: pageSize,
          pageNo: pageNo,
          total:total,
      }
    },
  },
  mounted() {
    this.myrank();
    this.query();
  }
};
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
	.ljjcaozuo .el-button [class*=el-icon-]+span{
		margin-left: 0;
	}
	.ljjcaozuo .h-el-icon{
		margin-right: 0;
	}
	.smTableRq .el-table tbody td .cell {
	    padding-top: 0.03rem;
	    padding-bottom: 0.03rem;
	}
	.smTableRq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.smTableRq .el-input__inner{
		background: transparent;
	}
	.ljjtablepaddingsrq .h-tableInput{
		margin-top: 0.05rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
		color: #616467;
		font-size: 0.16rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
